import React from 'react';
import {DateCell, LinkCell} from "../../../components/common/advance-table/CustomCells";
import {useFragment} from "react-relay";
import graphql from "babel-plugin-relay/macro";
import {Card} from "react-bootstrap";
import CardTableHeader from "../../../components/common/headers/CardTableHeader";
import AdvanceTable from "../../../components/common/advance-table/AdvanceTable";
import AdvanceTablePagination from "../../../components/common/advance-table/AdvanceTablePagination";
import AdvanceTableWrapper from "../../../components/common/advance-table/AdvanceTableWrapper";
import {FormatAddress} from "../../../helpers/utils";

const cols = [
    {accessor: 'applicableVersion.name',
        Header: 'Name',
        headerProps: { className: 'pe-1' },
        cellProps: {
            className: 'py-2'
        },
        Cell: rowData => {
            const location = rowData.row.original;
            return <LinkCell name={location.applicableVersion.name} to={"/locations/" + location.id} hasAvatar />
        }},
    {
        accessor: 'addressLine1',
        Header: 'Address',
        Cell: rowData => {
            const address = rowData.row.original;
            return <>{FormatAddress(address.addressLine1, address.addressLine2, "",
                address.city, address.state, address.postalCode)}</>
        }
    },
]
const LocationBillingGroup = ({locationBillingGroups}) => {
    const data = useFragment(graphql`
    fragment LocationBillingGroup on Location @relay(plural:true) {
        id
        applicableVersion {
            name
        }
        addressLine1
        addressLine2
        city
        state
        postalCode
    }`, locationBillingGroups)
    return (
        <>
            <AdvanceTableWrapper columns={cols}
                                 data={data}
                                 sortable
                                 pagination
                                 perPage={10}
                                 initialSortColumn="applicableVersion.name"
            >
                <Card className={"mb-3"}>
                    <Card.Header>
                        <CardTableHeader onNewClick={() => {}}
                                         title={"Locations"}
                                         table
                                         showNew={false} />
                    </Card.Header>
                    <Card.Body className={"p-0"}>
                        <AdvanceTable table
                                      headerClassName={"bg-200 text-900 text-nowrap align-middle"}
                                      rowClassName={"align-middle white-space-nowrap"}
                                      tableProps={{size: "sm", striped: true, className: "fs--1 mb-0 overflow-hidden"}}
                        />
                    </Card.Body>
                    <Card.Footer>
                        <AdvanceTablePagination table />
                    </Card.Footer>
                </Card>
            </AdvanceTableWrapper>
        </>
    )
}
export default LocationBillingGroup